/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Locale } from '@app/settings/locales/locales.model';
import { LocalesFormComponent } from '@app/settings/locales/locales-form/locales-form.component';
import { Logger } from '@app/core';

const log = new Logger('LocalesFormService');

@Injectable({
  providedIn: 'root',
})
export class LocalesFormService {
  constructor(private modalService: NgbModal) {}

  /**
   * Open locale form
   * @param locale Dialog data
   */
  public open(locale: null | Locale = null) {
    log.debug('open');
    const modal = this.modalService.open(LocalesFormComponent);
    modal.componentInstance.locale = locale;
    return modal.result;
  }
}
